export default __webpack_public_path__ + "static/media/malaysia1.0cb03311.jpg";